// pathsBus
// ========
//
// Wave 14ds: Singleton-Bus für die umliegenden Trail-Polylines, damit das
// Battery-Safe-Mode-Overlay (global in App.tsx) sie als dezenten Kontext-
// Layer ("nearby paths") in der Briefmarke zeichnen kann.
//
// Analog routeBus: MapPage hält `trails: CachedTrail[]` im Memory und
// publisht hier eine schlanke Polyline-Repräsentation (`[lat,lon][][]`),
// damit der Bus von der CachedTrail-Struktur entkoppelt bleibt und das
// Overlay nur die Geometrie sieht. Das Overlay bbox-filtert beim Draw auf
// den sichtbaren Radius — hier wird NICHT gefiltert (MapPage kennt die
// aktuelle Position des Overlays nicht).

import type { RoutePoint } from './routeBus'; // [lat, lon]

export type Listener = (paths: RoutePoint[][] | null) => void;

class PathsBus {
  private current: RoutePoint[][] | null = null;
  private readonly listeners = new Set<Listener>();

  get(): RoutePoint[][] | null {
    return this.current;
  }

  set(paths: RoutePoint[][] | null): void {
    this.current = paths && paths.length > 0 ? paths : null;
    for (const l of this.listeners) l(this.current);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const pathsBus = new PathsBus();
